/**
 * Created by shubham on 11/10/18.
 */

import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpService} from "../../shared/services/http.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DialogComponent} from "../../dialog/dialog.component";
import {MdDialog} from "@angular/material";
import {CommonService} from '../../shared/services/common.service';
import {ApplicationRejectActionDialogComponent} from '../../dialog/dialog.component';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { APPCONFIG } from '../../config';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'application-request',
    template: require('./viewApplicationRequest.component.html'),
})
export class ViewApplicationRequestComponent {

    dialogRef;
    urlId: any;
    ApplicationsRequestData: any;
    ApplicationsRequestForm: FormGroup;
    ApplicationsRequestFormDetails: any;
    public isApproved:boolean = false;
    public isReject:boolean = false;
    userDetails:any;
    roles = [];
    settings = {};
    selectedItems = [];
    applicationText: any;
    isSystemAdmin;
    isApplicationManager;
    isBUManager;
    showApproveButton: boolean = false;
    settingSingleField = {
        singleSelection: true,
        text:"Select Role",
        labelKey: "name",
        selectAllText:'Select All',
        unSelectAllText:'UnSelect All',
        classes:"myclass custom-class",
        disabled: false
    };
    settingMultipleField = {
        singleSelection: false,
        text:"Select Role",
        labelKey: "name",
        selectAllText:'Select All',
        unSelectAllText:'UnSelect All',
        classes:"myclass custom-class",
        disabled: false
    };

    constructor(private route: ActivatedRoute, public httpService : HttpService, private formBuilder: FormBuilder, public dialog: MdDialog,
                private commonService: CommonService,  private sessionHandler:SessionHandler, private translate: TranslateService) {

        this.applicationText = 'applicationManagerView';

        //Get URL param value
        this.route.params.subscribe(params => {
            this.urlId = params['id'];

            if(this.urlId != undefined || this.urlId != null){
                this.getApplicationRequestDataById(this.urlId);
            }
        });
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.applicationManager)) {
                this.isApplicationManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
        
        } else {
            this.httpService.noUserError();
        }
    }

    getApplicationRequestDataById(urlId){
        this.httpService.getRequest("applicationOperationApi/v1/applicationRequestsById/"+this.urlId).subscribe(
            res => { this.saveApplicationRequestDataById(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    saveApplicationRequestDataById(res){
        if(res){
            this.ApplicationsRequestData = res;
            this.commonService.changeViewData(this.ApplicationsRequestData, 'appView');
            if(this.ApplicationsRequestData){
                if(this.ApplicationsRequestData.multipleRole){
                    this.settings = this.settingMultipleField;
                } else{
                    this.settings = this.settingSingleField;
                }

                if(this.ApplicationsRequestData.applicationRoles){
                    this.roles = this.ApplicationsRequestData.applicationRoles;
                }
                if(this.ApplicationsRequestData.selectedRoles){
                    for(let l in this.ApplicationsRequestData.selectedRoles){
                        this.selectedItems.push({id: this.ApplicationsRequestData.selectedRoles[l]['id'], name: this.ApplicationsRequestData.selectedRoles[l]['name']});
                    }
                }
            }
        }
        this.httpService.onEnd();
    }

    buildForm() {
        this.ApplicationsRequestForm = this.formBuilder.group({
            selectedRoles: this.formBuilder.control(null, [Validators.required])
        });

        this.ApplicationsRequestForm.valueChanges.subscribe(data => {
            this.ApplicationsRequestFormDetails = this.ApplicationsRequestForm.getRawValue();

            if(this.urlId){
                this.ApplicationsRequestFormDetails['id'] = this.urlId;
            }

            if(this.ApplicationsRequestFormDetails['selectedRoles'].length > 0){
                this.showApproveButton = false;
            } else{
                this.showApproveButton = true;
            }

            this.ApplicationsRequestFormDetails.validate = this.ApplicationsRequestForm.valid;
        });
    }

    saveApplicationData(){
        if(this.ApplicationsRequestFormDetails['selectedRoles'].length <= 0){
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.isConfirm = true;
            this.dialogRef.componentInstance.msg = "app_revoke_confirm";
            this.dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.saveApplicationDataApi();
                }
            });
        } else {
            this.saveApplicationDataApi();
        }
    }

    saveApplicationDataApi(){
        this.httpService.postRequest(this.ApplicationsRequestFormDetails,'applicationOperationApi/v1/updateUserApplicationRoles').subscribe(
            res => {
                this.saveApplicationResponse(res);
            },
            err => { this.httpService.onEnd(); }
        );
    }
    saveApplicationResponse(res){
        if(res){
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = "Request submitted successfully.";
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/application-manager-dashboard';
            });
        } else if(res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    }

    appAction(status){
        this.dialogRef = this.dialog.open(ApplicationRejectActionDialogComponent);
        let actionStatus = "";
        if (status == 'APPROVED') {
            actionStatus = 'APPROVE';
            this.dialogRef.componentInstance.msg = 'rqst_approve_confirm';
            this.dialogRef.componentInstance.isApproved = true;
        } else if (status == 'REJECTED') {
            actionStatus = 'REJECT';
            this.dialogRef.componentInstance.msg = 'rqst_rjct_confirm';
            this.dialogRef.componentInstance.isRejected = true;
        }
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                let data = {};
                data['id'] = this.urlId;
                data['status'] = status;

                if(status == "REJECTED"){
                    data['message'] = result;
                } else{
                    data['selectedRoles'] = this.ApplicationsRequestFormDetails['selectedRoles'];
                }

                let today = new Date();
                let dd = ('0' + today.getDate()).slice(-2);
                let mm = ('0' + (today.getMonth() + 1)).slice(-2);
                let yyyy = today.getFullYear();
                data['approvalDate'] = yyyy + '' + mm + '' + dd;

                this.httpService.postRequest(data, 'applicationOperationApi/v1/approveApplicationRequest').subscribe(
                    res => {
                        this.saveResponse(res, status);
                    },
                    err => {
                        this.httpService.onEnd();
                    }
                );
            }
        });
    }
    public saveResponse(res, status) {
        this.httpService.onEnd();
        let statusTxt;
        if (res) {
            if (status == 'APPROVED') {
                statusTxt = 'Approval process initiated. It will take time. User will be notified on mail.';
            } else {
                statusTxt = 'Rejected Successfully';
            }
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = statusTxt;
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/application-manager-dashboard';
            });
        }
    }

    ngOnInit() {
        this.buildForm();
        this.translate.get('Select Role').subscribe((res: string) => {
            this.settingSingleField.text = res;
            this.settingMultipleField.text = res;
        });
        this.translate.get('select_all').subscribe((res: string) => {
            this.settingSingleField.selectAllText = res;
            this.settingMultipleField.selectAllText = res;
        });
        this.translate.get('unselect_all').subscribe((res: string) => {
            this.settingSingleField.unSelectAllText = res;
            this.settingMultipleField.unSelectAllText = res;
        });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/viewApplicationRequest/viewApplicationRequest.component.ts